import $ from 'jquery';
import template from './profilePicture.html';

class ProfilePictureController {
    constructor($rootScope, messaging) {
        this.messaging = () => messaging;
        this.user = $rootScope.user;
    }

    activateNotification() {
        const messaging = this.messaging();
        messaging.requestPermission();
    }
    updateServiceWorker() {
        let e = $.Event('update-sw');
        $('body').trigger(e);
    }
}

ProfilePictureController.$inject = ['$rootScope', 'messaging'];

const ProfilePictureComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: ProfilePictureController,
    controllerAs: 'vm'
};

export { ProfilePictureComponent };



// WEBPACK FOOTER //
// ./app/components/common/navbar/profilePicture.component.js